<template>
    <section>
        <CheckoutComponent />
    </section>
</template>

<script>
    import LayoutDefault from "../../layouts/LayoutDefault";
    import CheckoutComponent from "../../components/checkout/CheckoutComponent";

    export default {
        name: "CheckoutPage",
        components: {CheckoutComponent},
        created() {
            this.$emit('update:layout', LayoutDefault)
        }
    }
</script>

<style scoped>

</style>
